export default "__VITE_ASSET__BGk3UZov__"